module.exports = __webpack_public_path__ + "static/img/gateway.56b82dfd.svg";